import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { FaEdit, FaFileImport } from 'react-icons/fa';
import { AiOutlineFileExcel, AiOutlinePlus } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';
import styles from '../../assets/css/TogglerButton.module.css';
import { activateStartUp, startUpList, uploadStartUpXls } from '../../Services/Utils/StartupApis';
import { notifySet } from '../../Services/Actions/CommonActions';
import { isEmpty } from '../../Services/config/globals';
import { UseStyles } from '../../components/TableStyles/tableSX';
import { downloadXL } from '../../Services/Utils/FileApis';
import FileUpload from '../../common/uploadFile';

function Toggler(props) {
  const dispatch = useDispatch();
  const { startUpData } = props;
  const [isStartUpActive, setIsStartUpActive] = useState(startUpData.active);

  const handlleStartUpActiveChange = (e, res) => {
    activateStartUp({ id: res.id }).then((resp) => {
      if (resp.hasError === false) {
        dispatch(notifySet({ type: 'success', message: resp.message }));
        setIsStartUpActive(!isStartUpActive);
      } else if (resp.hasError === true) {
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  };
  return (
    <label className={styles.switch}>
      <input
        type="checkbox"
        id="Btn"
        className={`${styles['switch-input']}`}
        checked={isStartUpActive}
        onChange={(e) => handlleStartUpActiveChange(e, startUpData)}
      />
      <span className={`${styles.slider} ${styles['slider-round']}`} />
    </label>
  );
}

function UserMaster() {
  const dispatch = useDispatch();
  const classes = UseStyles();

  // table pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [itemOffset, setItemOffset] = useState(0);
  const [listRecordSize, setListRecordSize] = useState(0);
  const onPageChange = (event, newPage) => {
    setPage(newPage);
    const newOffset = (newPage * rowsPerPage) % listRecordSize;
    setItemOffset(newOffset);
  };
  const handleChangeRowsPerPage = (event) => {
    setrowsPerPage(event.target.value);
  };
  const [startUp, setStartUp] = useState([]);

  function startUpView() {
    const data = {
      roleView: {
        id: 2,
      },
    };
    const params = {
      start: itemOffset,
      recordSize: rowsPerPage,
    };

    if (!isEmpty(inputValue)) {
      data.fullTextSearch = inputValue;
    }

    startUpList(data, params).then((res) => {
      setStartUp(res.list);
      setListRecordSize(res.records);
    });
  }
  useEffect(() => {
    startUpView();
  }, [itemOffset, rowsPerPage]);

  const downloadFile = () => {
    const data = {
      roleView: {
        id: 2,
      },
    };
    if (!isEmpty(inputValue)) {
      data.fullTextSearch = inputValue;
    }
    downloadXL('user', data);
  };

  // search startup
  const [inputValue, setInputValue] = useState('');
  const handleClickSearchBar = () => {
    startUpView();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      startUpView();
    }
  };

  // import startup

  const onChange = (info) => {
    const data = { file: info.file };
    uploadStartUpXls(data).then((res) => {
      const { hasError, message } = res;
      if (hasError === false) {
        dispatch(notifySet({ type: 'success', message }));
        startUpView();
      } else {
        dispatch(notifySet({ type: 'error', message }));
      }
    });
  };

  return (
    <div>
      <div className="title-con">
        <div className="row align-items-center">
          <div className="col-sm-12 col-md-12 col-lg-3">
            <div className="title-left-con">
              <h6>Startups</h6>
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-9">
            <div className="title-right-con list-ul-con">
              <ul>
                <li>
                  <div>
                    <Paper
                      sx={{
                        p: '2px 4px',
                        display: 'flex',
                        alignItems: 'center',
                        width: 300,
                      }}
                    >
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        placeholder="search"
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e)}
                        value={inputValue}
                      />
                      <IconButton
                        type="button"
                        sx={{ p: '10px' }}
                        aria-label="search"
                        onClick={handleClickSearchBar}
                      >
                        <SearchIcon />
                      </IconButton>
                    </Paper>
                  </div>
                </li>
                <li>
                  <FileUpload
                    onChange={onChange}
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  >
                    <button className="btn btn-primary">
                      <FaFileImport style={{ marginRight: '10px' }} />
                      Import
                    </button>
                  </FileUpload>
                </li>
                <li>
                  <Link
                    className={`addcircle excel${isEmpty(startUp) ? ' disabled' : ''}`}
                    title={isEmpty(startUp) ? 'Empty Data' : 'Download data in XL format'}
                    onClick={!isEmpty(startUp) ? downloadFile : () => {}}
                  >
                    <AiOutlineFileExcel />
                  </Link>
                </li>
                <li>
                  <Link
                    className="addcircle"
                    to="/add-startups"
                  >
                    <AiOutlinePlus />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {isEmpty(startUp) && <p className="text-center" style={{ marginTop: '100px' }}>No startup found</p> }
      {isEmpty(startUp) ? (
        ''
      ) : (
        <div>
          <Paper sx={{ overflow: 'hidden', marginTop: '30px' }}>
            <TableContainer
              component={Paper}
              className="tableContainer"
              sx={{ maxHeight: 720, marginRight: 'auto' }}
            >
              <Table
                stickyHeader
                className={classes.root}
              >
                <TableHead>
                  <TableRow>
                    <TableCell width={60}>No.</TableCell>
                    <TableCell>Startup Name</TableCell>
                    <TableCell>Registered Name</TableCell>
                    <TableCell>Founder Detail</TableCell>
                    <TableCell>CIIE PM Details</TableCell>
                    <TableCell>Plan</TableCell>
                    <TableCell width={100}>Status</TableCell>
                    <TableCell width={100}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {startUp.map((startUpData, key) => (
                    <TableRow
                      key={key}
                      hover
                      tabIndex={-1}
                      className="muiTableRow"
                    >
                      <TableCell>{key + 1 + itemOffset}</TableCell>
                      <TableCell>{startUpData.name}</TableCell>
                      <TableCell>{startUpData.registeredName}</TableCell>
                      <TableCell>
                        {startUpData.founderName}
                        <br />
                        {startUpData.email}
                        <br />
                        {startUpData.mobile}
                      </TableCell>
                      <TableCell>
                        {startUpData.pocName}
                        <br />
                        {startUpData.pocEmail}
                        <br />
                        {startUpData.pocMobile}
                      </TableCell>
                      <TableCell>{startUpData.planView?.name}</TableCell>
                      <TableCell>
                        <Toggler startUpData={startUpData} />
                      </TableCell>
                      <TableCell>
                        <Tooltip title="Edit">
                          <Link
                            to={`/edit-startups/${startUpData.id}`}
                            style={{ verticalAlign: 'text-bottom' }}
                          >
                            <FaEdit style={{ color: 'black', fontSize: '20px' }} />
                          </Link>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 20]}
              component="div"
              count={listRecordSize}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={onPageChange}
              onRowsPerPageChange={handleChangeRowsPerPage}
              className="tablepaginationcon"
            />
          </Paper>
        </div>
      )}
    </div>
  );
}

export default UserMaster;
